import {useEffect} from 'react'

export default useEffect
